import emptyCadastroBase from '../../para/empty/emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
  },
  json: {
    tipo: 'CANCELAMENTO_CLAUSULA_RESOLUTIVA',
    numeroProcesso: null,
    dataEmissaoTituloDominial: null,
    numeroTituloDominial: null,
    cadastrante: {
      oficio: null,
      solicitacao: null,
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          matricula: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null
        },
        telefones: []
      },
      documentos: []
    },
    interessado: {
      pessoa: {
        tipo: 'PJ',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        profissao: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null
        },
        telefones: []
      },
      documentos: []
    },
    imovel: {
      id: null,
      documentos: [],
      denominacao: null,
      area: 0,
      areaString: '',
      localizacao: null,
      municipio: null,
      // matricula
      cnsMatricula: null,
      numeroMatricula: null,
      livroMatricula: null,
      numeroFolhaMatricula: null,
      // dados do titulo
      nomeBeneficiarioTitulo: null,
      dataRegistro: null,
      nomeCartorio: null,
      municipioCartorio: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/maranhao/empty/emptyLiberacaoClausulaResolutiva.js